"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8107],{

/***/ 82863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExerciseIDE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95496);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(8987);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(88409);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(40044);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(50135);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(46901);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(92401);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(33841);
/* harmony import */ var _mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(18972);
/* harmony import */ var _mui_material_Select__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(153);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26447);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56254);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25617);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3751);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_timer_hook__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74231);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34444);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65907);
/* harmony import */ var _components_Scrollbar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91045);
/* harmony import */ var _components_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(733);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77364);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9671);
/* harmony import */ var _service_hackerthon_hackerthon_code_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51839);
/* harmony import */ var _utils_formatNumber__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87850);
/* harmony import */ var _utils_languages__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34412);
/* eslint-disable react/prop-types */ 






// @mui























var MonacoEditor = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 3764).then(__webpack_require__.bind(__webpack_require__, 63764)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63764)
            ];
        }
    },
    ssr: false
});
var TabPanelStyle = (0,_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
        height: "calc(100vh - 95px)",
        display: "flex"
    }, theme.breakpoints.down("xs"), {
        height: "100vh"
    });
});
function ExerciseIDE() {
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)().translate;
    var exercise = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.hackerthonExercise;
    }).exercise;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(200), editorHeight = ref[0], setEditorHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showConsole = ref1[0], setShowConsole = ref1[1];
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_4__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var isAuthenticated = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().isAuthenticated;
    var NewItemSchema = yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry().shape({
        language: yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_().required(translate("validation.required")),
        sourcecode: yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_().required(translate("validation.required"))
    });
    var defaultValues = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            language: _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .LANGUAGES[0].name */ .a[0].name,
            sourcecode: _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .LANGUAGES[0].code */ .a[0].code,
            theme: _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .THEMES[0] */ .y[0]
        };
    }, []);
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_2__/* .yupResolver */ .X)(NewItemSchema),
        defaultValues: defaultValues
    });
    var watch = methods.watch, control = methods.control, setValue = methods.setValue, getValues = methods.getValues, handleSubmit = methods.handleSubmit, isSubmitting = methods.formState.isSubmitting;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var subscription = watch(function(value, param) {
            var name = param.name;
            if (name === "language") {
                var data = _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .LANGUAGES.find */ .a.find(function(item) {
                    return item.name === value.language;
                });
                setValue("sourcecode", data.code, {
                    shouldValidate: true
                });
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, [
        watch,
        setValue
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), response = ref2[0], setResponse = ref2[1];
    var onRun = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
            var request, ref, code, data, message;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToJmaster"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        request = {
                            language: getValues("language"),
                            sourcecode: getValues("sourcecode"),
                            testCases: (exercise === null || exercise === void 0 ? void 0 : exercise.testCases) || []
                        };
                        return [
                            4,
                            (0,_service_hackerthon_hackerthon_code_service__WEBPACK_IMPORTED_MODULE_15__/* .checkCodeAPI */ .vF)(request)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data, message = ref.message;
                        if (code === "200") {
                            setResponse(data);
                            !showConsole && handleShowConsole(); //show console
                        } else if (code === "403") enqueueSnackbar("".concat(translate("label.signinToJmaster")), {
                            variant: "error"
                        });
                        else enqueueSnackbar("".concat(code, " : ").concat(message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onRun() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function(request) {
            var ref, code, data, message;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToJmaster"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        //add exercise id
                        request.exerciseId = exercise === null || exercise === void 0 ? void 0 : exercise.id;
                        return [
                            4,
                            (0,_service_hackerthon_hackerthon_code_service__WEBPACK_IMPORTED_MODULE_15__/* .submitCodeAPI */ .I_)(request)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data, message = ref.message;
                        if (code === "200") {
                            setResponse(data);
                            !showConsole && handleShowConsole(); //show console
                        } else if (code === "403") enqueueSnackbar("".concat(translate("label.signinToJmaster")), {
                            variant: "error"
                        });
                        else enqueueSnackbar("".concat(code, " : ").concat(message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(request) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowConsole = function() {
        var show = !showConsole;
        setShowConsole(show);
        setEditorHeight(show ? 550 : 200);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .FormProvider */ .RV, {
        methods: methods,
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TabPanelStyle, {
            spacing: 1,
            p: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
                                    name: "language",
                                    control: control,
                                    render: function(param) {
                                        var field = param.field, error = param.fieldState.error;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                    children: translate("ide.language")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Select__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({
                                                    size: "small",
                                                    label: translate("ide.language")
                                                }, field), {
                                                    error: !!error,
                                                    sx: {
                                                        width: 150
                                                    },
                                                    children: _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .LANGUAGES.map */ .a.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                            value: item.name,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                direction: "row",
                                                                spacing: 2,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                        src: item.image,
                                                                        sx: {
                                                                            height: 15,
                                                                            width: 15
                                                                        },
                                                                        alt: item.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                                        variant: "subtitle2",
                                                                        children: item.title
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    })
                                                }))
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
                                    name: "theme",
                                    control: control,
                                    render: function(param) {
                                        var field = param.field, error = param.fieldState.error;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                    children: translate("ide.theme")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Select__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({
                                                    size: "small",
                                                    label: translate("ide.theme")
                                                }, field), {
                                                    error: !!error,
                                                    sx: {
                                                        width: 100
                                                    },
                                                    children: _utils_languages__WEBPACK_IMPORTED_MODULE_17__/* .THEMES.map */ .y.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                            value: item,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                                variant: "subtitle2",
                                                                children: item
                                                            })
                                                        }, index);
                                                    })
                                                }))
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stopwatcher, {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
                    name: "sourcecode",
                    control: control,
                    render: function(param) {
                        var field = param.field, error = param.fieldState.error;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MonacoEditor, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, field), {
                            fullWidth: true,
                            error: !!error,
                            options: {
                                minimap: {
                                    enabled: false
                                }
                            },
                            width: "100wh",
                            height: "calc(100vh - ".concat(editorHeight, "px)"),
                            language: watch("language").toLowerCase() === "cs" ? "csharp" : watch("language").toLowerCase(),
                            theme: watch("theme")
                        }));
                    }
                }),
                showConsole && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Scrollbar__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Console, {
                        response: response,
                        testCases: exercise === null || exercise === void 0 ? void 0 : exercise.testCases
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                    type: "button",
                                    color: "inherit",
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        icon: "clarity:play-solid",
                                        sx: {
                                            height: 20,
                                            width: 20
                                        }
                                    }),
                                    onClick: onRun,
                                    children: translate("button.run")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                    type: "button",
                                    color: "inherit",
                                    variant: "text",
                                    onClick: handleShowConsole,
                                    startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        icon: showConsole ? "solar:double-alt-arrow-down-line-duotone" : "solar:double-alt-arrow-up-line-duotone",
                                        sx: {
                                            height: 20,
                                            width: 20
                                        }
                                    }),
                                    children: "Console"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                            type: "submit",
                            variant: "contained",
                            loading: isSubmitting,
                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                icon: "tabler:send",
                                sx: {
                                    height: 20,
                                    width: 20
                                }
                            }),
                            children: translate("button.submit")
                        })
                    ]
                })
            ]
        })
    });
}
function Console(param) {
    var response = param.response, _testCases = param.testCases, testCases = _testCases === void 0 ? [] : _testCases;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), tab = ref2[0], setTab = ref2[1];
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)().translate;
    if (response) {
        var statusCode = response.statusCode, verdict = response.verdict, error = response.error, testCasesResults = response.testCasesResults;
        var renderTestCase = function() {
            var ref, ref1, ref2;
            return (testCasesResults === null || testCasesResults === void 0 ? void 0 : testCasesResults.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                        value: tab,
                        onChange: function(_, v) {
                            return setTab(v);
                        },
                        variant: "scrollable",
                        allowScrollButtonsMobile: true,
                        children: testCasesResults === null || testCasesResults === void 0 ? void 0 : testCasesResults.map(function(testCaseResult, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                value: index,
                                label: "Test #".concat(index),
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    icon: "radix-icons:dot-filled",
                                    sx: {
                                        color: testCaseResult.verdictStatusCode === 100 ? "green" : "red"
                                    }
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        label: translate("hackerthon.testCaseResult.input"),
                        value: (ref = testCasesResults[tab]) === null || ref === void 0 ? void 0 : ref.input,
                        disabled: true,
                        multiline: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        label: translate("hackerthon.testCaseResult.expectedOutput"),
                        value: (ref1 = testCasesResults[tab]) === null || ref1 === void 0 ? void 0 : ref1.expectedOutput,
                        disabled: true,
                        multiline: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        label: translate("hackerthon.testCaseResult.output"),
                        value: (ref2 = testCasesResults[tab]) === null || ref2 === void 0 ? void 0 : ref2.output,
                        disabled: true,
                        multiline: true
                    })
                ]
            });
        };
        if (statusCode !== 100) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            spacing: 2,
            my: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                    severity: "error",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
                            children: [
                                statusCode,
                                " : ",
                                verdict
                            ]
                        }),
                        error
                    ]
                }),
                renderTestCase()
            ]
        });
        else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            spacing: 2,
            my: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                    severity: "success",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
                            children: [
                                verdict,
                                " (",
                                statusCode,
                                ")"
                            ]
                        }),
                        "Runtime: ",
                        (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_16__/* .fNumber */ .FK)(response.averageExecutionDuration),
                        " ms"
                    ]
                }),
                renderTestCase()
            ]
        });
    }
    if ((testCases === null || testCases === void 0 ? void 0 : testCases.length) > 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        spacing: 2,
        my: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                value: tab,
                onChange: function(_, v) {
                    return setTab(v);
                },
                children: testCases === null || testCases === void 0 ? void 0 : testCases.map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                        value: index,
                        label: "Test #".concat(index)
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                label: translate("hackerthon.testCaseResult.input"),
                value: (ref = testCases[tab]) === null || ref === void 0 ? void 0 : ref.input,
                multiline: true,
                disabled: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                label: translate("hackerthon.testCaseResult.expectedOutput"),
                value: (ref1 = testCases[tab]) === null || ref1 === void 0 ? void 0 : ref1.expectedOutput,
                multiline: true,
                disabled: true
            })
        ]
    });
    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
        variant: "subtitle2",
        children: "Console:"
    });
}
function Stopwatcher() {
    var ref = (0,react_timer_hook__WEBPACK_IMPORTED_MODULE_7__.useStopwatch)({
        autoStart: true
    }), seconds = ref.seconds, minutes = ref.minutes, hours = ref.hours, reset = ref.reset;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                variant: "subtitle2",
                children: [
                    hours,
                    ":",
                    minutes,
                    ":",
                    seconds
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                icon: "system-uicons:reset-alt",
                sx: {
                    height: 12,
                    width: 12,
                    cursor: "pointer"
                },
                onClick: reset
            })
        ]
    });
}


/***/ }),

/***/ 18015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExerciseTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88409);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40044);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34444);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9671);
/* eslint-disable react/prop-types */ 




// ----------------------------------------------------------------------
function ExerciseTab(param) {
    var exercise = param.exercise, tab = param.tab;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().translate;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var TABS = [
        {
            value: "description",
            label: translate("hackerthon.exercise.description"),
            icon: "ph:question"
        },
        {
            value: "discussion",
            label: translate("hackerthon.exercise.discussion"),
            icon: "ant-design:comment-outlined"
        },
        {
            value: "solutions",
            label: translate("hackerthon.exercise.solution"),
            icon: "icons8:idea"
        },
        {
            value: "submissions",
            label: translate("hackerthon.exercise.submission"),
            icon: "bx:archive"
        }, 
    ];
    var handleChangeTab = function(_, v) {
        router.push("/exercises/".concat(exercise.slug, "/").concat(v));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: tab,
        onChange: handleChangeTab,
        variant: "scrollable",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
        sx: {
            boxShadow: 1,
            px: 1,
            mb: 1
        },
        children: TABS.map(function(t) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                value: t.value,
                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "subtitle2",
                    sx: {
                        textTransform: "initial"
                    },
                    children: t.label
                }),
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    icon: t.icon,
                    width: 16,
                    height: 16
                })
            }, t.value);
        })
    });
}


/***/ }),

/***/ 51839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I_": function() { return /* binding */ submitCodeAPI; },
/* harmony export */   "_m": function() { return /* binding */ runCodeAPI; },
/* harmony export */   "vF": function() { return /* binding */ checkCodeAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92369);



var runCodeAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/code/run",
                method: "POST",
                data: data
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequest */ .X)(config)
            ];
        });
    });
    return function runCodeAPI(data) {
        return _ref.apply(this, arguments);
    };
}();
var checkCodeAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/code/check",
                method: "POST",
                data: data
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequest */ .X)(config)
            ];
        });
    });
    return function checkCodeAPI(data) {
        return _ref.apply(this, arguments);
    };
}();
var submitCodeAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/code/submit",
                method: "POST",
                data: data
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequest */ .X)(config)
            ];
        });
    });
    return function submitCodeAPI(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 34412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ LANGUAGES; },
/* harmony export */   "y": function() { return /* binding */ THEMES; }
/* harmony export */ });
var LANGUAGES = [
    {
        name: "CPP",
        title: "C++",
        image: "/icons/cpp.png",
        code: "#include <iostream>\r\nusing namespace std;\r\n// chu y de ten la main ham chinh\r\nint main() {\r\n \r\n\r\n}"
    },
    {
        name: "JAVA",
        title: "JAVA",
        image: "/icons/java.png",
        code: "// chu y de class la main\r\npublic class main {\r\n  public static void main(String[] args) {\r\n\r\n  }\r\n}"
    },
    {
        name: "PYTHON",
        title: "PYTHON",
        image: "/icons/python.png",
        code: ""
    },
    {
        name: "C",
        title: "C",
        image: "/icons/c.png",
        code: "#include <stdio.h>\r\n\r\n// chu y de ten la main ham chinh\r\nint main() {\r\n\r\n}"
    }, 
];
var THEMES = [
    "vs-dark",
    "vs-light",
    "hc-black"
];


/***/ })

}]);